import {Component, TemplateRef, ViewChild} from '@angular/core';
import {BlockBaseComponent} from "../block-base/block-base.component";
import {TranslocoService} from "@ngneat/transloco";
import {StoreSelectorsService} from "../../../../services";

@Component({
    selector: 'app-scene-block-label',
    templateUrl: './block-label.component.html',
    styleUrls: ['./block-label.component.scss']
})
export class BlockLabelComponent extends BlockBaseComponent {

    @ViewChild("pricingModal", {read: TemplateRef}) pricingModal: TemplateRef<any>;
    // @ViewChild('fontLoader', {static: false}) fontSelector: FontSelectorComponent;

    fontsPreviewed: Array<string> = [];

    // m_fontScene: Array<any> = [];
    // pricingModalDiag;
    // totalFontsToPreview = 0;
    // httpRequests = [];

    constructor(private translocoService: TranslocoService, public override storeSelector: StoreSelectorsService) {
        super(storeSelector);
    }

    override submit(formValues) {
        // formValues.Text = _.escape(formValues.Text);
        // formValues.Text = formValues.Text.replace(/</ig, '&lt;').replace(/>/ig, '&gt;').replace(/&/ig, '&amp;');
        // formValues.Text = formValues.Text.replace(/'/ig, '`');
        if (Array.isArray(formValues.Text)) {
            return super.submit(formValues);
        } else {
            return super.submit({Text: [formValues.Text]});
        }
    }

    override componentInit() {
        super.componentInit();
    }

    override componentStoreUpdates() {
        super.componentStoreUpdates();
        super.initApplyStoreToDynamic(true);
    }

    override initRegisterDynamic() {
        this.uiConfigInit = [
            {
                type: "input",
                value: '',
                label: this.translocoService.translate('general.displayedText', {}, this.translocoService.getActiveLang()),
                inputType: "textarea",
                name: "Text",
                restrictChar: 'basic0',
                storePath: 'Data[0].Label[0].Text'
            }
        ];
        this.uiConfigInit = this.appendGpu(this.uiConfigInit);
    }
}

